function Queries() {
  this.cache = {};
  this.getQuery = function getQuery({ state, query }) {
    if (query === undefined) throw new Error('Query is undefined');
    if (this.cache[query]) return this.cache[query];
    const queryTags = state.tags.filter(tag => tag.display.toLowerCase().includes(query));
    const queryResources = [];

    const queryGroups = Array.from(new Set(queryTags.map(tag => tag.group)));
    state.resources.forEach((resource) => {
      if (resource.name.toLowerCase().includes(query)
      || resource.description.toLowerCase().includes(query)
      || resource.buOffice.toLowerCase().includes(query)
      || resource.email.toLowerCase().includes(query)) {
        queryResources.push(resource);
        return;
      }
      resource.tags.some((tag) => {
        if (queryGroups.includes(tag._id)) {
          queryResources.push(resource);
          return true;
        }
        return false;
      });
    });
    this.cache[query] = {
      tags: queryTags,
      resources: queryResources,
    };
    return this.cache[query];
  };
}

export function getQueriesFromString(string) {
  let queryArray;
  if (string && string.trim().length > 0) {
    if (string.includes('"')) {
      queryArray = string.trim().toLowerCase().replace(/\s+/g, ' ').match(/(?:[^\s"]+|"[^"]*")+/g);
      if (queryArray) queryArray = queryArray.map(query => query.replace(/"/g, ''));
    } else queryArray = string.trim().toLowerCase().replace(/\s+/g, ' ').split(' ');
  }
  if (!queryArray) queryArray = [];
  return queryArray;
}

export function getPotentialResources({ queries, state }) {
  if (queries.length === 0) return state.resources;

  let potentialResources = [];
  queries.forEach((query, index) => {
    if (index === 0) {
      potentialResources = state.queries.getQuery({ state, query }).resources;
      return;
    }
    if (potentialResources.length < 1) return;
    potentialResources = potentialResources.filter(resource => (
      state.queries.getQuery({ state, query }).resources.includes(resource)
    ));
  });
  return potentialResources;
}

export default function queriesReducer(state, action) {
  if (state.queries === undefined) return { ...state, queries: new Queries(state) };
  switch (action.type) {
    case 'ADD_RESOURCE':
    case 'UPDATE_RESOURCE':
    case 'ADD_TAG':
    case 'UPDATE_TAG':
    case 'DELETE_TAG':
    case 'ADD_GROUP':
    case 'UPDATE_GROUP':
    case 'DELETE_GROUP':
      return {
        ...state,
        queries: new Queries(state),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/queries.js